module.exports = __webpack_public_path__ + "media/images/marketing/spiral-up-a0d6b5b17b61bd01ce8549d07daabc834bd4fa565f6a9f5bfca12895b5c956df.png";